import { FC } from 'react';

import {
  Button,
  Col,
  Form,
  InputCore,
  InputPasswordCore,
  Row,
} from '@components';
import type { IAuth } from '@coreAuth/type';
import styles from './index.module.scss';
import { useGoogleLogin } from '@react-oauth/google';
import { FcGoogle } from 'react-icons/fc';
import { useStore } from '@store';
import { useNavigate } from 'react-router-dom';

interface ISigninTagProp {
  authCallback: (data: IAuth) => void;
  onNoAccClick: () => void;
  loading: boolean;
  onGoogleAuthSuccess?: () => void;
}

interface IResponse {
  Status: boolean;
  ErrorMessage?: any;
  SessionId: string;
  user_info: Userinfo;
}
interface Userinfo {
  UserID: number;
  UserName: string;
  Gender?: any;
  UserTypeTitle: string;
  UserTypeID: number;
  Mobile?: any;
  BirthDate?: any;
  FirstName?: any;
  LastName?: any;
  fullName: string;
  BusinessModelID: number;
  BusinessModelTitle: string;
  StartDate: string;
  ExpireDate: string;
  Photo?: any;
}

const SigninTag: FC<ISigninTagProp> = ({
  authCallback,
  onNoAccClick,
  loading,
}) => {
  const navigate = useNavigate();
  const { setAuthState } = useStore();

  const loginGoogle = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      console.log(tokenResponse);

      fetch('https://app.tadatoon.com/api/trust/google/start2', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: tokenResponse.access_token,
        }),
      })
        .then((res) => res.json())
        .then((data: IResponse) => {
          console.log('Backend response:', data);
          localStorage.setItem('sessionId', data.SessionId);
          localStorage.setItem('userId', String(data.user_info.UserID));
          setAuthState(data.SessionId, String(data.user_info.UserID));
          navigate('/dashboard', { replace: true });
        });
    },
  });

  return (
    <div className={styles['login_reg_container']}>
      <div className={styles['title']}>
        <h1 className="text-pink title">Sign in</h1>
      </div>
      <Form
        className={styles['log_reg_form']}
        labelCol={{ span: 24 }}
        onFinish={authCallback}>
        <div>
          <Row gutter={40}>
            <Col xs={24}>
              <Form.Item label="Email" name="username" required>
                <InputCore />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item label="Password" name="password" required>
                <InputPasswordCore />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div className={styles['button_card']}>
          <Button block loading={loading} type="primary" htmlType={'submit'}>
            Sign In
          </Button>
        </div>
        <div className={styles['button_card']}>
          <Button className={styles.googleButton} onClick={() => loginGoogle()}>
            <FcGoogle size={20} />
            <span>Sign in with Google</span>
          </Button>
        </div>
        <div className={styles['switch_forms']} onClick={() => onNoAccClick()}>
          <span className={styles['link']}>Don’t have an account ? </span>
          <span className={styles['link']}>Create an account !</span>
        </div>
      </Form>
    </div>
  );
};

export default SigninTag;
